import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchTeacherDetails, unassignTeacherThunk, fetchOrgUsersById } from "./redux/userThunk";
import userStore from "../../zustand/userStore";

const TeacherDetails = ({ teacherId, onClose }) => {
  const dispatch = useDispatch();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const userData = userStore((state) => state.user);

  useEffect(() => {
    if (teacherId) {
      setLoading(true);
      dispatch(fetchTeacherDetails(teacherId))
        .unwrap()
        .then((data) => {
          setTeacher(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err?.message || "Failed to load teacher details");
          setLoading(false);
        });
    }
  }, [teacherId, dispatch]);

  const handleUnassign = async () => {
    if (!window.confirm("Are you sure you want to remove/unassign this teacher?")) {
      return;
    }
    setLoading(true);
    try {
      await dispatch(unassignTeacherThunk(teacherId)).unwrap();
      alert("Teacher unassigned successfully!");
      dispatch(fetchOrgUsersById(userData?.id));
      if (onClose) onClose();
    } catch (err) {
      alert(err || "Failed to unassign teacher");
    } finally {
      setLoading(false);
    }
  };

  if (loading && !teacher) {
    return <div style={{ padding: "20px", textAlign: "center" }}>Loading teacher details...</div>;
  }

  if (error) {
    return <div style={{ padding: "20px", color: "red", textAlign: "center" }}>{error}</div>;
  }

  return (
    <div style={{ padding: "16px" }}>
      {teacher ? (
        <div>
          <table className="table table-sm table-borderless" style={{ fontSize: "14px", marginBottom: "20px" }}>
            <tbody>
              <tr>
                <td style={{ fontWeight: "600", width: "120px" }}>Name:</td>
                <td>{teacher.name || "N/A"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "600" }}>Qualification:</td>
                <td>{teacher.qualification || "N/A"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "600", width: "170px" }}>Max Periods Per Day:</td>
                <td>{teacher.max_periods_per_day !== undefined ? teacher.max_periods_per_day : "N/A"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              style={{ padding: "6px 16px", borderRadius: "5px" }}
              disabled={loading}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleUnassign}
              style={{ padding: "6px 16px", borderRadius: "5px" }}
              disabled={loading}
            >
              {loading ? "Removing..." : "Remove Teacher"}
            </button>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>No teacher data found.</div>
      )}
    </div>
  );
};

export default TeacherDetails;
